import api from '../../../services/api';
import {
  evalExport, evalGet, evalParams, listOf,
} from '../../../components/performance/evaluation/evaluationAnalytics';

// PM Analitik P4 — E07 Yönetici Değerlendirme Davranışı (/performance/rater-behavior) veri katmanı — YALNIZ İK.
//   GET v1/performance-evaluation-analytics/rater-behavior/summary     (M05, inceleme eşiğindeki yönetici, M23, M25)
//   GET …/rater-behavior/managers?sort=name|teamN&order&pageNumber&pageSize (+ export=xlsx)
//   GET …/rater-behavior/findings
//   POST v1/performance-actions                                       (İnceleme kaydı: yöneticiye bağlı PM aksiyonu)
// ETİK SINIR: yöneticiler arasında sıralama/bileşik kalite puanı yoktur — liste ada (ya da ekip n'ine) göre; metriğe göre
// sıralama sunucuda 400'dür, burada sütunlar sıralanamaz.

export const NS = 'performance.raterBehavior';

export const Q = {
  rater: 'rater',
  minTeamN: 'minn',
  reviewStatuses: 'review',
  signals: 'signal',
};
export const SCREEN_KEYS = Object.values(Q);

export const REVIEW_STATUSES = ['none', 'open', 'done'];
export const SIGNALS = ['deviationHigh', 'deviationLow', 'selfGap', 'repeatedDelay', 'compression'];
export const MIN_TEAM_OPTIONS = ['5', '10', '20', '50'];
export const SORTABLE = { managerName: 'name', teamN: 'teamN' };

export function screenFilters(values) {
  return {
    'raterEmployeeId[eq]': values[Q.rater] || null,
    minTeamN: values[Q.minTeamN] || null,
    'reviewStatus[in]': listOf(values[Q.reviewStatuses]),
    'signal[in]': listOf(values[Q.signals]),
  };
}

export const fetchSummary = (filters, screen) => evalGet('rater-behavior/summary', evalParams(filters, screen));
export const fetchFindings = (filters, screen) => evalGet('rater-behavior/findings', evalParams(filters, screen));

const managerParams = (filters, screen, {
  sort, order, pageNumber, pageSize,
} = {}) => ({
  ...evalParams(filters, screen),
  ...(sort ? { sort, order: order || 'asc' } : {}),
  ...(pageNumber ? { pageNumber, pageSize } : {}),
});

export const fetchManagers = (filters, screen, options) => evalGet('rater-behavior/managers', managerParams(filters, screen, options));
export const exportManagers = (filters, screen, options) => evalExport('rater-behavior/managers', managerParams(filters, screen, { ...options, pageNumber: null }));

/** İnceleme kaydı: yöneticiye bağlı (linkedScopeType=manager) kalibrasyon inceleme aksiyonu. Bildirim/hata interceptor'da. */
export async function createReviewRecord({
  periodId, managerEmployeeId, title, ownerEmployeeId, dueDate, description,
}) {
  try {
    const res = await api.post('/v1/performance-actions', {
      title,
      ownerEmployeeId,
      dueDate,
      actionType: 'calibration_candidate',
      periodId,
      description: description || null,
      linkedScopeType: 'manager',
      linkedScopeId: managerEmployeeId,
      sourceInsightId: null,
      teamLabel: null,
    });
    return !!res?.data?.status;
  } catch {
    return false;
  }
}
